import { Injectable, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorModalComponent } from '~app/shared/components/error-modal/error-modal.component';
import { ModalService } from '~app/shared/services/modal/modal.service';
import { SpinnerService } from '~app/shared/services/spinner/spinner.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(
    private readonly modal: ModalService,
    private readonly injector: Injector,
    private readonly spinner: SpinnerService,
    private readonly zone: NgZone,
  ) {}

  public handleError(error: any): any {
    try {
      console.error(error);
      const router = this.injector.get(Router);
      const message: string =
        this.msg(error) ||
        this.msg(error.rejection) ||
        this.msg(error.message) ||
        this.msg(error.rejection.message) ||
        'There was an unexpected issue';

      this.zone.run(() => {
        this.modal.open(ErrorModalComponent, message);
      });

      this.spinner.hide();
      // If the user is not on a loaded screen, take the user to a crash screen
      if (!router.navigated) {
        router.navigate(['/error/crash']);
      }
    } catch (err) {
      console.error(err);
      alert('There was critical error');
    }
  }

  private msg(prop: any): string | false {
    try {
      if (typeof prop !== 'string') return false;
      if (/\.js:[0-9]*:[0-9]*/g.test(prop)) return false; // Regex that looks for not user friendly messages
      return prop;
    } catch (error) {
      return false;
    }
  }
}
